import { HttpClient, HttpEventType } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { EmbedVideoService } from 'ngx-embed-video';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'upload-video',
    templateUrl: 'upload-video.component.html',
    styleUrls: ['upload-video.component.scss']
})
export class UploadVideoComponent {
    constructor(
      public fb: FormBuilder,
      private cd: ChangeDetectorRef,
      private http: HttpClient,
      private embedService: EmbedVideoService
    ) {

        
    
    }
  
    /*##################### Registration Form #####################*/
    registrationForm = this.fb.group({
      file: [null]
    })  
  
    /*########################## File Upload ########################*/
    @ViewChild('fileInput') el: ElementRef;
    imageUrl: any = 'assets/images/videotest.png';
    editFile: boolean = true;
    removeUpload: boolean = false;
  @Output() public onUploadFinished = new EventEmitter();

public progress: number;
  
    uploadFile(event) {
      let reader = new FileReader(); // HTML5 FileReader API
      let file = event.target.files[0];
      if (event.target.files && event.target.files[0]) {
        let fileToUpload = event.target.files[0];
const formData = new FormData();
formData.append('file', fileToUpload, fileToUpload.name);
this.http.post(`${environment.baseApiUrl}/Experience/UploadVideo`, formData, {reportProgress: true, observe: 'events'})
.subscribe(event => {
if (event.type === HttpEventType.UploadProgress)
     this.progress = Math.round(100 * event.loaded / event.total);
    else if (event.type === HttpEventType.Response) {
     this.uploadFinished(event.body);
   }
});
   
        reader.readAsDataURL(file);
  
        // When file uploads set it to file formcontrol
    
        // ChangeDetectorRef since file is loading outside the zone
        this.cd.markForCheck();        
      }
    }
    videoUploadedurl;
    uploading = true;
public response: {fileName: ''};

    public uploadFinished = (event) => {
        debugger;
      this.response = event;
      this.imageUrl=`${environment.apiUrl}/Resources/Experiences/`+event.value;
     this.onUploadFinished.emit(this.imageUrl);
     this.videoUploadedurl = this.embedService.embed(this.imageUrl,
        {
            query: { portrait: 0, color: '333' },
            attr: { width: 200, height: 100 }
        });
     this.uploading = false;
      this.editFile = false;
      this.removeUpload = true;
      }
    // Function to remove uploaded file
    removeUploadedFile() {
      let newFileList = Array.from(this.el.nativeElement.files);
      this.imageUrl = 'https://i.pinimg.com/236x/d6/27/d9/d627d9cda385317de4812a4f7bd922e9--man--iron-man.jpg';
      this.editFile = true;
      this.removeUpload = false;
      this.registrationForm.patchValue({
        file: [null]
      });
    }
    
    // Submit Registration Form
    onSubmit() {
      if(!this.registrationForm.valid) {
        alert('Please fill all the required fields to create a super hero!')
        return false;
      } else {
        console.log(this.registrationForm.value)
      }
    }
  
  }